import httpRequestAdmin from "./httpRequest/httpRequestAdmin";

class CommonService {
  getCurrencies() {
    return httpRequestAdmin.get(process.env.REACT_APP_BACKEND_API_URL + "common/currencies");
  }
}

export default new CommonService();
